import _ from 'lodash';
export const checkIsEmpty = data => {
  return _.isEmpty(data);
};
